export function setWrapClass(limitations) {
  const { breakfastsMinLimit, entreesMinLimit } = limitations;

  if (breakfastsMinLimit === 0 && entreesMinLimit > 0) return { reverse: true };
  
  return { reverse: false };
}
